import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Low"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#FAD208"
      fillRule="evenodd"
      d="M16.956 12.969c.424 1.25-.685 2.348-2.005 2.348H5.097c-1.32 0-2.429-1.098-2.005-2.348a7.32 7.32 0 0 1 13.864 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLow;
